/** @jsxImportSource @emotion/react */
import _ from "lodash";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { services } from "../../../services";
import { EditComponent, ScaffoldMain, useAlertListener } from "../../../ui";

import * as styles from "./styles";

export const ProspectsEdit = () => {
  const params = useParams();
  const { addAlert } = useAlertListener();
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const [initForm, setInitForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    contacted: false,
  });

  const inputs = [
    {
      type: "text",
      placeholder: "Escribir nombre",
      label: "Nombre",
      name: "name",
    },
    {
      type: "email",
      placeholder: "Escribir email",
      label: "Email",
      name: "email",
    },
    {
      type: "phone",
      placeholder: "Escribir teléfono",
      label: "Teléfono",
      name: "phone",
    },
    {
      type: "textarea",
      placeholder: "Escribir mensaje",
      label: "Mensaje",
      name: "message",
    },
    {
      type: "boolean",
      label: "Contactado",
      labelNot: "No contactado",
      name: "contacted",
    },
  ];

  useEffect(() => {
    getUser();
  }, []);

  const getUser = async () => {
    try {
      setLoading(true);
      const resp = await services.prospectsShow(params.id || "");

      if (resp?.data?.body) {
        setInitForm({
          ..._.pick(resp.data.body, [
            "name",
            "email",
            "phone",
            "message",
            "type",
            "contacted",
          ]),
        });
      } else {
        navigate(-1);
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      addAlert({
        title: "Hubo un problema, intentarlo más tarde.",
        type: "alert",
      });
    }
  };

  const onReturn = async () => {
    navigate(-1);
  };

  const navigateSuccess = async () => {
    navigate("/prospects", { replace: true });
  };

  const navigateDestroy = async () => {
    navigate("/prospects", { replace: true });
  };

  return (
    <ScaffoldMain
      root="prospects"
      title="Editar prospecto"
      onReturn={onReturn}
      destroy={{
        id: params.id || "",
        serviceDestroy: services.prospectsDestroy,
        navigateDestroy,
      }}
    >
      <EditComponent
        initLoading={loading}
        initForm={initForm}
        inputs={inputs}
        service={(payload: any) =>
          services.prospectsUpdate(params.id || "", payload)
        }
        navigateSuccess={navigateSuccess}
        isEdit
      />
    </ScaffoldMain>
  );
};
